import arrow from '../assets/img/arrow.svg'
import image1 from '../assets/img/login/1.png'
import image2 from '../assets/img/login/2.png'

const SIgnIn = () => {
    return (
        <div>
            <div className="login-page__jumbotron">
                <h1 className="title">Log in</h1>
                <p className="sub-title">Hier gehts zu deiner Lernplattform, dem Blog sowie den kommenden Veranstaltungen.</p>
            </div>
            <div className="login__wrap">
                <div className="login-page__items">
                    <a href="/#" className="login-page__items__item">
                        <img className="img" src={image1} alt="img" />
                        <div className="title">Zur Lernplattform im Nachwuchsfußball</div>
                        <div className="arrow">
                            <img src={arrow} alt='arrow' />
                        </div>
                    </a>
                    <a href="/#" className="login-page__items__item">
                        <img className="img" src={image2} alt="img" />
                        <div className="title">Zum Blog und Veranstaltungen</div>
                        <div className="arrow">
                            <img src={arrow} alt='arrow' />
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default SIgnIn;

